interface ColumnWidth {
  width?: number | string
  minWidth?: number
  minResizableWidth?: number
  isHidden?: boolean
}

/** Reserve space for flexible columns before fixed-width columns consume the viewport. */
export const getTableMinWidth = (columns: readonly ColumnWidth[]): number | undefined => {
  const visibleColumns = columns.filter(column => !column.isHidden);
  if (!visibleColumns.some(column => column.minWidth !== undefined || column.minResizableWidth !== undefined)) {
    return undefined;
  }

  return visibleColumns.reduce((total, column) => {
    const width = typeof column.width === 'number' ? column.width : Number(column.width?.replace(/px$/, '')) || 0;
    return total + Math.max(width, column.minWidth ?? column.minResizableWidth ?? 0);
  }, 0);
};
